/**
 * Agregat tlumaczen. Kazdy obszar aplikacji ma wlasny plik JSON, zeby przy
 * ~1000 kluczach dalo sie jeszcze cokolwiek znalezc i zeby konflikty w gicie
 * byly lokalne.
 *
 * Parytet kluczy PL/EN pilnuje `npm run i18n:check` (scripts/check-locales.js).
 */
import enAccount from './en/account.json'
import enApp from './en/app.json'
import enAuth from './en/auth.json'
import enBuilder from './en/builder.json'
import enCommon from './en/common.json'
import enComponents from './en/components.json'
import enCreateApp from './en/createApp.json'
import enDevice from './en/device.json'
import enErrors from './en/errors.json'
import enMedia from './en/media.json'
import enMessages from './en/messages.json'
import enNav from './en/nav.json'
import enRegion from './en/region.json'
import enRoles from './en/roles.json'
import enUsers from './en/users.json'
import enValidation from './en/validation.json'
import enWorkspace from './en/workspace.json'

import plAccount from './pl/account.json'
import plApp from './pl/app.json'
import plAuth from './pl/auth.json'
import plBuilder from './pl/builder.json'
import plCommon from './pl/common.json'
import plComponents from './pl/components.json'
import plCreateApp from './pl/createApp.json'
import plDevice from './pl/device.json'
import plErrors from './pl/errors.json'
import plMedia from './pl/media.json'
import plMessages from './pl/messages.json'
import plNav from './pl/nav.json'
import plRegion from './pl/region.json'
import plRoles from './pl/roles.json'
import plUsers from './pl/users.json'
import plValidation from './pl/validation.json'
import plWorkspace from './pl/workspace.json'

export default {
  en: {
    account: enAccount,
    app: enApp,
    auth: enAuth,
    builder: enBuilder,
    common: enCommon,
    components: enComponents,
    createApp: enCreateApp,
    device: enDevice,
    errors: enErrors,
    media: enMedia,
    messages: enMessages,
    nav: enNav,
    region: enRegion,
    roles: enRoles,
    users: enUsers,
    validation: enValidation,
    workspace: enWorkspace
  },
  pl: {
    account: plAccount,
    app: plApp,
    auth: plAuth,
    builder: plBuilder,
    common: plCommon,
    components: plComponents,
    createApp: plCreateApp,
    device: plDevice,
    errors: plErrors,
    media: plMedia,
    messages: plMessages,
    nav: plNav,
    region: plRegion,
    roles: plRoles,
    users: plUsers,
    validation: plValidation,
    workspace: plWorkspace
  }
}
